import { useRef } from 'react';
import type { ResolvedColumn, ResolvedFilter } from '../../domain';
import {
    lockedFilterParamName,
    parseFilters,
} from '../../domain/query/url-params';
import type { UrlAdapter } from '../../ports';

export function useUrlLockedFilters<T>(
    id: string,
    url: UrlAdapter | false,
    columns: ResolvedColumn<T>[],
): ResolvedFilter[] {
    const rawRef = useRef<string | null>(null);
    const lockedRef = useRef<ResolvedFilter[]>([]);

    const raw =
        url === false
            ? null
            : new URLSearchParams(url.getSearch()).get(
                  lockedFilterParamName(id),
              );

    if (raw !== rawRef.current) {
        rawRef.current = raw;
        lockedRef.current = raw
            ? parseFilters(raw, columns).map((f) => ({ ...f, locked: true }))
            : [];
    }

    return lockedRef.current;
}
